import * as Sentry from "@/utils/logger.util";

export const captureException = (error: any) => {
  if (process.env["NODE_ENV"] !== "development") {
    Sentry.captureException(error);
  } else {
    console.error(error);
  }
};
